"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsButton = exports.TabsButtons = exports.StyledContainer = exports.StyledBox = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _colorChart = require("../color-chart/color-chart.styled");

var _headerTitles = require("../header-titles/header-titles.styled");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 27px;\n  font-weight: bold;\n  margin: 0 10px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  color: ", ";\n  &.active {\n    border-bottom: 3px solid ", ";\n    cursor: default;\n  }\n  ", " {\n    font-size: 14px;\n    line-height: 21px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  list-style: none;\n  margin-bottom: 60px;\n  margin-top: 0;\n  padding-left: 0;\n  ", " {\n    margin-bottom: 30px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    max-width: 1170px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", " {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    ", " {\n      padding-top: 15px;\n      padding-bottom: 15px;\n    }\n  }\n  ", " {\n    justify-content: center;\n  }\n  ", " {\n    text-align: center !important;\n  }\n  ", " {\n    text-align: center !important;\n  }\n  ", " {\n    text-align: center !important;\n  }\n  ", " {\n    ", " {\n      max-width: 1170px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), _colorChart.ContainerStyled, _uiKit.GridBreakpointsMediaDown.sm, _colorChart.ListStyled, _headerTitles.OverlineStyled, _headerTitles.HeadlineStyled, _colorChart.ColorChartHeadingStyled, _uiKit.GridBreakpointsMediaUp.xl, _colorChart.ContainerStyled);
exports.StyledBox = StyledBox;
var StyledContainer = (0, _uiKit.styled)(_uiKit.Container)(_templateObject2(), _uiKit.GridBreakpointsMediaUp.xl);
exports.StyledContainer = StyledContainer;
var TabsButtons = (0, _uiKit.styled)('ul')(_templateObject3(), _uiKit.GridBreakpointsMediaDown.md);
exports.TabsButtons = TabsButtons;
var TabsButton = (0, _uiKit.styled)('li')(_templateObject4(), _uiKit.Colors.gray800, _uiKit.Colors.primaryDark, _uiKit.GridBreakpointsMediaDown.md);
exports.TabsButton = TabsButton;